import { roleOptions } from './step-template-shares';
import { FormValue } from '../resource-templates-form-page';
import {
  CalendarRoles,
  isAbleToSeeUIElement,
} from '../../../../utils/roles/client-roles';
import { useUserSettings } from '../../../../utils/use-user-settings';
import SharedReviewLayout, {
  ReviewSection,
} from '../../../../shared/shared-review-layout';

interface StepReviewProps {
  selectedTemplate: FormValue;
}

export default function StepReview({ selectedTemplate }: StepReviewProps) {
  const { calendarRoles } = useUserSettings();

  const resourceCategoryOptions = [
    { displayValue: 'Undefined', value: 'Resource Category' },
    ...(isAbleToSeeUIElement(
      calendarRoles,
      CalendarRoles.CanSelectCategoryUnknown.value
    )
      ? [{ displayValue: 'Unknown', value: 'CATEGORY_UNKNOWN' }]
      : []),
    ...(isAbleToSeeUIElement(
      calendarRoles,
      CalendarRoles.CanSelectConferenceRoom.value
    )
      ? [{ displayValue: 'Conference Room', value: 'CONFERENCE_ROOM' }]
      : []),
    ...(isAbleToSeeUIElement(calendarRoles, CalendarRoles.CanSelectOther.value)
      ? [{ displayValue: 'Other', value: 'OTHER' }]
      : []),
  ];

  const sections: ReviewSection[] = [
    {
      title: 'Basic Information',
      leftWidth: {
        labelWidth: 2.5,
        valueWidth: 8.5,
      },
      leftItems: [
        { label: 'Template Name', value: selectedTemplate.name ?? '' },
        { label: 'Description', value: selectedTemplate.desc ?? '' },
        {
          label: 'Resource Category',
          value: selectedTemplate.resourceCategory
            ? resourceCategoryOptions.find(
                (opt) => opt.value === selectedTemplate.resourceCategory
              )?.displayValue
            : '',
        },
        { label: 'Resource Type', value: selectedTemplate.resourceType ?? '' },
        {
          label: 'Building',
          value: selectedTemplate.building
            ? selectedTemplate.building.buildingName
            : '',
        },
        { label: 'Floor', value: selectedTemplate.floorName ?? '' },
        { label: 'Floor Section', value: selectedTemplate.floorSection ?? '' },
        { label: 'Capacity', value: selectedTemplate.capacity ?? '' },
      ],
    },
    {
      title: 'Template Shares',
      leftWidth: {
        labelWidth: 2.5,
        valueWidth: 8.5,
      },
      leftItems: [
        {
          label: 'Domain Role',
          value: !selectedTemplate.calSharedToDomain
            ? 'N/A'
            : selectedTemplate.domainRole
            ? roleOptions.find(
                (opt) => opt.value === selectedTemplate.domainRole
              )?.displayValue
            : '',
        },
        {
          label: 'Public Role',
          value: !selectedTemplate.calPublic
            ? 'N/A'
            : selectedTemplate.publicRole
            ? roleOptions.find(
                (opt) => opt.value === selectedTemplate.publicRole
              )?.displayValue
            : '',
        },
        {
          value: selectedTemplate.shares
            ? Object.keys(selectedTemplate.shares).map((user) => ({
                email: user.split(':')[1],
                type:
                  user.split(':')[0] === 'user'
                    ? ('User' as const)
                    : ('Group' as const),
              }))
            : null,
          variant: 'chip',
          flex: true,
          isVisible: !!(
            selectedTemplate.shares &&
            Object.keys(selectedTemplate.shares).length > 0
          ),
        },
      ],
    },
  ];

  return <SharedReviewLayout sections={sections} />;
}
